<section class="open" data-testid="open-page">
  <menu-buttons-header label="Abrir"></menu-buttons-header>

  <div class="select-door-text" *ngIf="openFunctionalityIsAvailable" data-testid="open-select-door-message">
    <p>1º Selecciona qué puerta quieres abrir</p>
    <selectable-menu-buttons class="button-container"
       #doorButtons
      [topActions]="topActions"
      (actionClick)="onMenuButtonClick($event)">
    </selectable-menu-buttons>
  </div>

  <div class="select-door-text" *ngIf="openFunctionalityIsAvailable" data-testid="open-slider-message">
    <p>2º Desliza para abrir</p>
    <unlock-slider
      *ngIf="openFunctionalityIsAvailable"
      data-testid="open-unlock-slider"
      label="Desliza para abrir"
      (unlocked)="onUnlock()">
    </unlock-slider>
</div>

  <div class="hero" *ngIf="openFunctionalityIsAvailable" data-testid="open-hero">
    <div class="warning-icon">
      <svg width="100" height="88.496" viewBox="0 0 100 88.496" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M98.2251 74.7827L57.5319 5.10386C55.6418 1.77526 52.9734 0 49.9714 0C47.0807 0 44.3011 1.77526 42.4109 5.10386L1.6066 74.7827C-0.283518 78.0003 -0.505885 81.218 0.939501 83.7699C2.38489 86.3218 5.27566 87.6533 9.0559 87.6533L90.8869 87.6533C94.6672 87.6533 97.558 86.2109 99.0033 83.7699C100.449 81.218 100.115 78.0003 98.2251 74.7827ZM95.1119 81.5508C94.4448 82.6604 92.9994 83.2151 90.887 83.2151L9.0559 83.2151C6.94341 83.2151 5.38684 82.5494 4.83092 81.5508C4.16382 80.4413 4.38619 78.777 5.49802 77.0017L46.4136 7.32293C47.5254 5.43672 48.8596 4.43814 50.0826 4.43814C51.3056 4.43814 52.751 5.54768 53.7517 7.32293L94.4448 77.0017C95.4455 78.777 95.779 80.4413 95.1119 81.5508ZM53.3069 65.4626C53.3069 67.3488 51.8615 68.7912 49.9714 68.7912C48.0813 68.7912 46.6359 67.3488 46.6359 65.4626C46.6359 63.5764 48.0813 62.134 49.9714 62.134C51.8615 62.134 53.3069 63.5764 53.3069 65.4626ZM53.3069 33.2861L53.3069 54.3672C53.3069 56.2534 51.8615 57.6958 49.9714 57.6958C48.0813 57.6958 46.6359 56.2534 46.6359 54.3672L46.6359 33.2861C46.6359 31.3998 48.0813 29.9574 49.9714 29.9574C51.8615 29.9574 53.3069 31.3998 53.3069 33.2861L53.3069 33.2861Z" fill="currentColor" transform="translate(0.083 0.069)" />
        </g>
      </svg>
    </div>
    <p>No abras si no estás delante de la puerta</p>
  </div>

  <modal-check-in-legal-advice [show]="showCheckinLegalAdviceModal" (close)="closeCheckinLegalAdviceModal()" *ngIf="showCheckinLegalAdviceModal"></modal-check-in-legal-advice>
  <modal-check-in-hosts-count [pendingHostsCounts]="pendingHostsCounts" [showCloseButton]="false" [show]="showCheckinPendingHostModal" (close)="closeCheckinPendingHostModal()"  title="Check-In" *ngIf="showCheckinPendingHostModal"></modal-check-in-hosts-count>
</section>
